'use client'
import { authFetch } from '@/lib/auth/auth-fetch'
import { useWallet } from '@/providers/WalletContext'
import { useQuery } from '@tanstack/react-query'

export type HyperliquidBalance = {
	withdrawable: string
	marginSummary?: { accountValue: string }
	assetPositions?: Array<{
		position: { coin: string; szi: string; entryPx?: string; positionValue?: string }
	}>
	perp?: { withdrawable: string; accountValue?: string }
	spot?: {
		usdc: string
		usdh: string
		// Net of `hold` (funds locked in open orders). Use these for any
		// "can the user place an order of size X" guard — `usdc`/`usdh`
		// are TOTAL holdings and over-state available balance for traders
		// with resting limit orders.
		usdcAvailable?: string
		usdhAvailable?: string
		balances: Array<{ coin: string; token: number; total: string; hold: string }>
	}
}

export function useHyperliquidBalance(enabled = true) {
	const { authenticated } = useWallet()
	return useQuery({
		queryKey: ['hl-balance'],
		enabled: enabled && authenticated,
		refetchInterval: 20_000,
		queryFn: async (): Promise<HyperliquidBalance> => {
			// Privy bearer auth — server (/api/hyperliquid/balance) verifies
			// via resolveUser → requireAuthUser; without the headers the
			// route returns 401.
			const r = await authFetch('/api/hyperliquid/balance')
			if (!r.ok) throw new Error(`balance ${r.status}`)
			return r.json()
		},
	})
}
